<template>
  <div ref="host" class="h-100">
    <NMap @mousemove.native="mouseMoveHandler" @mouseout.native="mouseOutHandler" class="h-100">
      <NTilesLayer />
      <template v-for="(layer, i) of layers">
        <NTilesLayer :key="layer.name" v-if="layer && !layer.styleURL" :layer="layer"/>
        <NWMSLayer :key="layer.name" v-if="layer && layer.styleURL" :srs="srs" :layer="layer" :loader="loader" :info="infos[i]" :style="layer.opacity()"/>
      </template>
    </NMap>
    <transition name="fade">
      <div v-if="loader.numLoading" class="lottie">
        <Lottie></Lottie>
      </div>
    </transition>
    <div class="map-actions">
      <div class="zoom-action" @click="zoomIn">
        <img src="../../assets/img/plus.svg" alt />
      </div>
      <div class="zoom-action" @click="zoomOut">
        <img src="../../assets/img/minus.svg" alt />
      </div>
    </div>
    <div v-if="info" class="position-absolute chart-tooltip" :style="{ left: (info.x + 10) + 'px', top: info.y + 'px' }" v-html="info.value"></div>
  </div>
</template>


<script>
import Lottie from "@/components/shared/Lottie.vue";
import {
  CenterScale,
  FocusModel,
  Loader,
  SRS,
  Timer,
  WMSInfo,
  defaultFocusModel
} from "vue-niney";
import NMap from "vue-niney/NMap.vue";
import NTilesLayer from "vue-niney/NTilesLayer.vue";
import NWMSLayer from "vue-niney/NWMSLayer.vue";
export default {
  name: "Map",
  components: {
    NMap,
    NTilesLayer,
    NWMSLayer,
    Lottie
  },
  props: {
    layers: { type: Array }
  },
  data() {
    const srs = new SRS();
    srs.minX = -20010000;
    srs.minY = -7540851.04344194;
    srs.maxX = 20010000;
    srs.maxY = 17903109.435964;
    
    return {
      srs: srs,
      loader: new Loader(),
      infos: this.layers.map(layer => null)
    };
  },
  created: function() {
    this.timer = new Timer(650, 1);
  },
  methods: {
    mouseMoveHandler(mouseEvent) {
      this.timer.reset();
      this.timer.timerHandler = () => {
        var clientRect = this.$refs.host.getBoundingClientRect();
        var mouseX = mouseEvent.clientX - clientRect.left;
        var mouseY = mouseEvent.clientY - clientRect.top;
        this.infos = this.layers.map(layer => {
          if ((layer != null) && (layer.infoConverter != null)) {
            const wmsInfo = new WMSInfo(mouseX, mouseY);
            wmsInfo.infoConverter = layer.infoConverter;
            return wmsInfo;
          }
          return null;
        });
      };
      this.timer.start();
      this.infos = this.layers.map(layer => null);
    },
    mouseOutHandler(mouseEvent) {
      this.timer.stop();
      this.infos = this.layers.map(layer => null);
    },
    zoomIn: function() {
      var cs = defaultFocusModel.animationCenterScale;
      defaultFocusModel.setCenterScale(
        new CenterScale(cs.centerX, cs.centerY, cs.scale / 2),
        FocusModel.ALWAYS_NEAREST
      );
    },
    zoomOut: function() {
      var cs = defaultFocusModel.animationCenterScale;
      defaultFocusModel.setCenterScale(
        new CenterScale(cs.centerX, cs.centerY, cs.scale * 2),
        FocusModel.ALWAYS_NEAREST
      );
    }
  },
  computed: {
    info() {
      const infos = this.infos.filter(info => info != null);
      if (infos.length == 0) {
        return null;
      }
      if (infos.some(info => info.value == null)) {
        return {
          x: infos[0].x,
          y: infos[0].y,
          value: "Loading..."
        };
      }
      return {
        x: infos[0].x,
        y: infos[0].y,
        value: infos.map(info => info.infoConverter(info.value)).join("<br/><br/>")
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.map-actions {
  position: absolute;
  right: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  img {
    width: 30px;
  }
}
.zoom-action {
  margin-bottom: 10px;
  cursor: pointer;
}
</style>

